module.exports = __webpack_public_path__ + "img/login.c8d81853.jpeg";